import React from 'react';
import ContentSelfProvisionWA from '../components/pages/self-provision-WA/existingUser/content';
import { connect } from 'react-redux';

const WASelfProvisionExistingUser = (props) => {
  return (
    <div>
      <ContentSelfProvisionWA
        showWaitingAreaSelfProvisionCreateModal={props.showWaitingAreaSelfProvisionCreateModal}
        selfProvisionCreateForm={props.selfProvisionCreateForm}
        dispatch={props.dispatch}
      />
    </div>
  );
};
function mapStateToProps(state) {
  return {
    selfProvisionCreateForm: state.waitingAreaReducer.selfProvisionCreateForm,
    showWaitingAreaSelfProvisionCreateModal: state.modalReducer.showWaitingAreaSelfProvisionCreateModal || false,
  };
}

export default connect(mapStateToProps, null)(WASelfProvisionExistingUser);
